import ApplicationController from "./application_controller";
import StimulusReflex from "stimulus_reflex";
import $ from "jquery";

export default class extends ApplicationController {
  static targets = ["hm0_output"];

  connect() {
    super.connect();
    StimulusReflex.register(this);
    console.log("Objectif commercial controller js en cours ..");
    MicroModal.init();

    var self = this;


    if ($("#search").length && $("#quick_sort").length) {
      //on est sur la vue list

      //on est sur la vue list
      //  if ($("#activate_em").length) {
      //       this.show_edition_multiple();
      //  }
      this.rerender();
      (function ($) {
        $.each(["show", "hide"], function (i, ev) {
          var el = $.fn[ev];
          $.fn[ev] = function () {
            this.trigger(ev);
            return el.apply(this, arguments);
          };
        });
      })(jQuery);
      $("#spinner").on("show", function () {
        $("#total_entries").hide();
      });
      $("#spinner").on("hide", function () {
        $("#total_entries").show();
      });

      $("#mySidebar #table_custom_ .switch input").each(function () {
        let me = $(this);
        if (
          me.attr("type") === "checkbox" &&
          me.attr("class").includes("preference_columns")
        ) {
          me[0].addEventListener("change", (e) => {
            let hiddenHtmlClass = e.target.id.replace("filterrific_", "");
            console.log(hiddenHtmlClass);
            if (e.target.checked) {
              console.log("show ", e.target);
              $("." + hiddenHtmlClass).show();
            } else {
              console.log("hide ", e.target);
              $("." + hiddenHtmlClass).hide();
            }
          });
        }
      });
      /////

      var targetElement = document.getElementById("mySidebar");
      targetElement.addEventListener("scroll", (event) => {
        var element = document.getElementById("mySidebar");
        document.getElementById("scrollevel").value = element.scrollTop;
      });


      this.handleSidebarScroll("objectif_commercial_");

    }
  }

  iniFla() {
    let fields = document.querySelectorAll(".flatpickr");

    for (let j = 0; j < fields.length; j++) {
      fields[j].classList.add("fx-input-date-sidbar-menu");
    }
  }



  afterRemovePref(element) {
    console.log("afterRemovePref afterRemovePref afterRemovePref");
    $(".child-loader").show();
    $("#filterrific_filter").submit();
  }

  beforeRemovePref(element) {
    console.log("afterRemovePref afterRemovePref afterRemovePref");
    $(".child-loader").show();
    $("#filterrific_filter").submit();
  }


  get params() {
    return this.data.get("params");
  }

  get current_app() {
    return this.data.get("app");
  }

  get objectif_commercials_id() {
    return this.data.get("objectif_commercialsid");
  }

  get url_solution() {
    return this.data.get("urlsolution");
  }
}
